export default {
  page: {
    title: 'Text generator',
    subtitle: 'Tools',
  },
  card: {
    title: 'Generation settings',
  },
  form: {
    text: {
      label: 'Text',
      placeholder: 'Enter the text to generate',
    },
    selected: {
      label: 'Selected:',
    },
    enableSubWord: {
      label: 'Avoid words contained in other words',
    },
  },
  button: {
    generate: 'Generate',
    clear: 'Clear',
    download: 'Download',
  },
  result: {
    list: {
      label: 'List:',
    },
    generatedText: {
      label: 'Generated text:',
      placeholder: 'The generated text will appear here',
    },
  },
  popover: {
    title: 'Selected words',
    description: 'selected',
  },
  alert: {
    repeatedWord: 'Repeated word! {word}',
  },
  help: {
    title: 'Instructions',
    steps: [
      'Type or paste the text.',
      'Select a word.',
      'Press Ctrl+B to mark it.',
      'Click Generate.',
      'Download the file.',
    ],
  },
};
